<style>
@media (min-width: 768px) {
    .background {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
    }
    .container {
        background: white;
        max-width: 768px;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }
}
@media (max-width: 767px) {
    .background {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
    }
    .container {
        background: white;
        width: 100%;
        height: 100%;

    }
}
</style>

<div class="background">
    <div class="container">
        <slot></slot>
    </div>
</div>